import { createWSClient } from '@/sockets/helpers/createWsClient';

export const wsClient = createWSClient();
